import { Headers } from '@egw/components'
import { ApplicationUnderReview } from '@egw/features-auth'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const ApplicationUnderReviewPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.application_under_review.title')} />
      <ApplicationUnderReview />
    </Layout>
  )
}
